 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"runtime": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"401":"401","404":"404","auth-redirect":"auth-redirect","bar-chart":"bar-chart","vendors~mapFull":"vendors~mapFull","mapFull":"mapFull","chunk-commons":"chunk-commons","draggable-dialog":"draggable-dialog","line-chart":"line-chart","login":"login","mixed-chart":"mixed-chart","profile":"profile","redirect":"redirect"}[chunkId]||chunkId) + "." + {"401":"b193cbe3","404":"a8766b50","auth-redirect":"85b48dc6","bar-chart":"3d402f25","chunk-3696a632":"1ba0eb00","chunk-6e83591c":"43f6310a","vendors~mapFull":"b52a2d3b","mapFull":"22516d8a","chunk-commons":"3e69af01","chunk-01b8cd87":"e99f07ea","chunk-043bde0d":"5d83d44c","chunk-04ef4760":"cca8682d","chunk-2089b05c":"234b427b","chunk-083e3b6b":"c442016c","chunk-0b4584b6":"55297c60","chunk-0b863bb6":"3d74945e","chunk-26ace588":"5eab617d","chunk-47675fe2":"3931cedb","chunk-8504b424":"18f8c49d","chunk-0e78b36e":"44591c24","chunk-790acce8":"19429b39","chunk-7bbc5713":"4c939e2a","chunk-7c2761bb":"1c4d2c2e","chunk-b85fec2a":"5575bcab","chunk-f16445b6":"6c107e94","chunk-f2e4f240":"c5bf9bdf","chunk-b133a1ce":"841e6769","chunk-5ef5d635":"ed7e8d52","chunk-40ffc6eb":"e9a47772","chunk-4a2fe39b":"5924f49f","chunk-5a2f9c7b":"9587a793","chunk-5123b358":"281de285","chunk-5a5e920e":"b814cb95","chunk-6700088c":"88766eca","chunk-6b0ba6fc":"efedf13a","chunk-e02447dc":"b7ce9822","chunk-1da3b4a0":"09a3a799","chunk-6ed0b60e":"21ce69f9","chunk-6ef767f4":"0225f228","chunk-735636bc":"bcf63921","chunk-902bf452":"510b7340","chunk-a9cbb5c0":"546b323a","chunk-b256bff4":"be50f395","chunk-cf48d93a":"d9ce844e","chunk-d6435dd2":"e4037535","draggable-dialog":"88aa5d65","line-chart":"10d53820","login":"082c5353","mixed-chart":"2440ea45","profile":"710a483a","redirect":"386e7c04","chunk-2d0aecdd":"ffe8c547","chunk-2d0b6b1b":"3e5a5c08","chunk-2d0bd7e3":"b76a2de0","chunk-2d0c117c":"dc6ec331","chunk-2d0c11b8":"b8a3ab8d","chunk-2d0c1947":"bc2bc4c5","chunk-2d0c1d94":"ea2c6a4a","chunk-2d0c4642":"ccedaaf8","chunk-2d0cc455":"d0658d8d","chunk-2d0cec09":"5766e252","chunk-2d0d3114":"48968dfc","chunk-2d0d317e":"6ebdbb57","chunk-2d0d6344":"26a47ad4","chunk-2d0d65cf":"30e3fc99","chunk-2d0d6760":"8d89681d","chunk-2d0d72f0":"ca637aad","chunk-2d0d9fa0":"57190fd7","chunk-2d0da410":"0a0bdea6","chunk-2d0dabb1":"f0da910d","chunk-2d0e1d30":"be6841aa","chunk-2d0e2c35":"470397cf","chunk-2d0e5b09":"490ed9ae","chunk-2d0f0a0f":"3334d0f2","chunk-2d207747":"1e9684e6","chunk-2d208a1f":"f453e9ac","chunk-2d2161d2":"fbeb14c1","chunk-2d21d9f2":"e9cc7923","chunk-2d21e3a2":"6e0bbcf6","chunk-2d225427":"d38d30d2","chunk-2d229b7d":"9146a964","chunk-2d22bd83":"b2bf026c","chunk-2d22c712":"82d2010b","chunk-2d230287":"2bd16cf7","chunk-2d231233":"02168dd9","chunk-3eeba882":"48591749"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"401":1,"404":1,"bar-chart":1,"chunk-3696a632":1,"mapFull":1,"chunk-commons":1,"chunk-01b8cd87":1,"chunk-043bde0d":1,"chunk-2089b05c":1,"chunk-0b4584b6":1,"chunk-0b863bb6":1,"chunk-47675fe2":1,"chunk-0e78b36e":1,"chunk-790acce8":1,"chunk-7bbc5713":1,"chunk-7c2761bb":1,"chunk-b85fec2a":1,"chunk-f16445b6":1,"chunk-f2e4f240":1,"chunk-5ef5d635":1,"chunk-4a2fe39b":1,"chunk-5a2f9c7b":1,"chunk-6b0ba6fc":1,"chunk-1da3b4a0":1,"chunk-6ef767f4":1,"chunk-d6435dd2":1,"line-chart":1,"login":1,"mixed-chart":1,"profile":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"401":"401","404":"404","auth-redirect":"auth-redirect","bar-chart":"bar-chart","vendors~mapFull":"vendors~mapFull","mapFull":"mapFull","chunk-commons":"chunk-commons","draggable-dialog":"draggable-dialog","line-chart":"line-chart","login":"login","mixed-chart":"mixed-chart","profile":"profile","redirect":"redirect"}[chunkId]||chunkId) + "." + {"401":"10048f6e","404":"6603768f","auth-redirect":"31d6cfe0","bar-chart":"2d3e8550","chunk-3696a632":"c26660bd","chunk-6e83591c":"31d6cfe0","vendors~mapFull":"31d6cfe0","mapFull":"cb1d7942","chunk-commons":"62b116ba","chunk-01b8cd87":"bd9484c0","chunk-043bde0d":"ab60cf55","chunk-04ef4760":"31d6cfe0","chunk-2089b05c":"292e975a","chunk-083e3b6b":"31d6cfe0","chunk-0b4584b6":"7d57e245","chunk-0b863bb6":"27515b97","chunk-26ace588":"31d6cfe0","chunk-47675fe2":"576e1396","chunk-8504b424":"31d6cfe0","chunk-0e78b36e":"6f67e81a","chunk-790acce8":"2b2d4584","chunk-7bbc5713":"d1474586","chunk-7c2761bb":"65d84a6b","chunk-b85fec2a":"b7573507","chunk-f16445b6":"df767389","chunk-f2e4f240":"41470a97","chunk-b133a1ce":"31d6cfe0","chunk-5ef5d635":"6474b9a4","chunk-40ffc6eb":"31d6cfe0","chunk-4a2fe39b":"06a38eb0","chunk-5a2f9c7b":"6c427276","chunk-5123b358":"31d6cfe0","chunk-5a5e920e":"31d6cfe0","chunk-6700088c":"31d6cfe0","chunk-6b0ba6fc":"54d93b09","chunk-e02447dc":"31d6cfe0","chunk-1da3b4a0":"a8405e66","chunk-6ed0b60e":"31d6cfe0","chunk-6ef767f4":"4acf15d1","chunk-735636bc":"31d6cfe0","chunk-902bf452":"31d6cfe0","chunk-a9cbb5c0":"31d6cfe0","chunk-b256bff4":"31d6cfe0","chunk-cf48d93a":"31d6cfe0","chunk-d6435dd2":"0b205ff2","draggable-dialog":"31d6cfe0","line-chart":"06752649","login":"d9dd7a35","mixed-chart":"7ecaf1ac","profile":"072ce360","redirect":"31d6cfe0","chunk-2d0aecdd":"31d6cfe0","chunk-2d0b6b1b":"31d6cfe0","chunk-2d0bd7e3":"31d6cfe0","chunk-2d0c117c":"31d6cfe0","chunk-2d0c11b8":"31d6cfe0","chunk-2d0c1947":"31d6cfe0","chunk-2d0c1d94":"31d6cfe0","chunk-2d0c4642":"31d6cfe0","chunk-2d0cc455":"31d6cfe0","chunk-2d0cec09":"31d6cfe0","chunk-2d0d3114":"31d6cfe0","chunk-2d0d317e":"31d6cfe0","chunk-2d0d6344":"31d6cfe0","chunk-2d0d65cf":"31d6cfe0","chunk-2d0d6760":"31d6cfe0","chunk-2d0d72f0":"31d6cfe0","chunk-2d0d9fa0":"31d6cfe0","chunk-2d0da410":"31d6cfe0","chunk-2d0dabb1":"31d6cfe0","chunk-2d0e1d30":"31d6cfe0","chunk-2d0e2c35":"31d6cfe0","chunk-2d0e5b09":"31d6cfe0","chunk-2d0f0a0f":"31d6cfe0","chunk-2d207747":"31d6cfe0","chunk-2d208a1f":"31d6cfe0","chunk-2d2161d2":"31d6cfe0","chunk-2d21d9f2":"31d6cfe0","chunk-2d21e3a2":"31d6cfe0","chunk-2d225427":"31d6cfe0","chunk-2d229b7d":"31d6cfe0","chunk-2d22bd83":"31d6cfe0","chunk-2d22c712":"31d6cfe0","chunk-2d230287":"31d6cfe0","chunk-2d231233":"31d6cfe0","chunk-3eeba882":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
